module.exports = __webpack_public_path__ + "static/media/Video.29d02c57.mp4";